import { useBreakpoints } from '@vueuse/core';
import { computed } from 'vue';

export default function useMobile() {
    const breakpoint = useBreakpoints({
        mobil: 0,
        tablet: 769,
        laptop: 1024,
        desktop: 1226,
    });

    const isMobile = computed(() => {
        return breakpoint.active().value === 'mobil';
    });

    const isDesktop = computed(() => {
        return breakpoint.active().value === 'laptop' || breakpoint.active().value === 'desktop';
    });

    return { isMobile, isDesktop};
}
